import React, { useRef } from "react";
import SnackChip from "../SnackChip/SnackChip";
import {
  getLocalTranslation,
  useComponentVisibles,
} from "../../utils/functions";
import EditSvg from "../../assets/img/edit.svg";
import { ITemplateButtonOptions } from "../../pages/Survey/Template/TemplatePage";
import { PopulatedIssue } from "../../models/IssueModels";
import { getIssueImg } from "../../assets/img/issue/issue";

require("./CardIssue.scss");

interface ICardIssue {
  buttonsOption?: Array<ITemplateButtonOptions>;
  issues: PopulatedIssue[];
}

export const CardIssue = ({ buttonsOption, issues }: ICardIssue) => {
  const refs = useRef<(HTMLDivElement | null)[]>([]);
  const handleRefAssignment =
    (index: number) => (ref: HTMLDivElement | null) => {
      refs.current[index] = ref;
    };

  const { isComponentVisible, setComponentVisible } = useComponentVisibles(
    false,
    refs
  );
  const optionsButton = (indexData: number) => {
    const handleOptionClick = (optionIndex: number) => {
      const option = buttonsOption && buttonsOption[indexData][optionIndex];
      if (option && option.onClick) {
        setComponentVisible(indexData);
        option.onClick(indexData);
      }
    };

    return (
      <div
        key={indexData}
        className="table-options-menu"
        ref={handleRefAssignment(indexData)}
      >
        <div className="container-wrapper-options">
          <div
            className="wrapper-options"
            onClick={() => {
              setComponentVisible(indexData);
            }}
          >
            <img src={EditSvg} alt="edit"></img>
          </div>
          <div
            className={`container-options ${
              isComponentVisible[indexData] ? "open" : ""
            }`}
          >
            {buttonsOption![indexData].map(
              ({ label, onClick, colorTheme, icon, isLoading }, index) => (
                <div className="item-options " key={index}>
                  <div
                    key={index}
                    onClick={() => {
                      handleOptionClick(index);
                    }}
                    className={`menu-item menu-item-${colorTheme}`}
                  >
                    <span
                      className={`icon  icon-button-table color-${colorTheme}`}
                    >
                      {icon}
                    </span>
                    <span
                      className={`capitalize-first-letter color-${colorTheme}`}
                    >
                      {label}
                    </span>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {issues.map((template, index) => {
        return (
          <div
            key={template.id + index}
            className="col-lg-4 col-xl-4 card-issue-container"
          >
            <div className="card-wrapper">
              <div>
                <div className="wrapper-info">
                  <div className="wrapper-chip">
                    <div className="container-chip">
                      <SnackChip
                        label={template.category?.name}
                        borderRadius="sm"
                        color={template.category?.color}
                        backgroundColor={template.category?.background}
                        options={{ colorTextNeutral: true }}
                        iconLeft={template.category?.icon}
                        theme="resource"
                      />
                    </div>
                    {template.resourceId && (
                      <div className="container-chip">
                        <SnackChip
                          label=""
                          borderRadius="sm"
                          iconLeft={"icon-book-open"}
                          theme="issue"
                        />
                      </div>
                    )}
                  </div>
                  <div className="container-image">
                    <img
                      alt={template.severity}
                      className="img-library"
                      src={getIssueImg(template?.severity as unknown as string)}
                    ></img>
                  </div>
                </div>
                <div className="info-library">
                  <div className="library-name">
                    {template.translations &&
                      getLocalTranslation(template.translations).title}
                  </div>
                </div>
              </div>
              <div className="library-footer">
                <>{buttonsOption && optionsButton(index)}</>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};
